// upload image namespace
export const BUSINESS = 'business';
export const USER = 'user';
export const ITEM = 'item';
export const ITEM_ALL = 'item all';
export const INGREDIENT = 'ingredient';
export const INGREDIENT_ALL = 'ingredient all';

// upload file namespace
export const CUSTOMER = 'customer';
export const INGREDIENTS_PURCHASE_ORDER = 'ingredients purchase order';
export const ITEMS_PURCHASE_ORDER = 'items purchase order';
export const INGREDIENTS_ADJUSTMENT = 'ingredients adjustment';
export const ITEMS_ADJUSTMENT = 'items adjustment';
export const INGREDIENT_LIBRARY = 'ingredient library';
export const ITEM_LIBRARY = 'item library';
export const RECIPE = 'recipe';
